import './style.css';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface StepMarkerProps {
    current?: boolean;
    selected?: boolean;
    completed?: boolean;
    icon: IconDefinition;
    text: string;
    callback?: (() => void) | null;
}

const StepMarker: React.FC<StepMarkerProps> = ({ current, selected, completed = false, icon, text, callback = () => {} }) => {
    let className = 'step-marker ' + (completed ? ' completed ' : '') + (selected ? ' selected ' : '') + (current ? ' current ' : '');
    return (
        <div className={className}>
            <div
                className="step-marker-icon"
                onClick={callback ?? undefined}
            >
                <div>
                    <FontAwesomeIcon icon={icon} />
                </div>
            </div>
            <div className="step-marker-text">{text}</div>
        </div>
    );
};

export default StepMarker;
